import { render } from "./Pedidos.vue?vue&type=template&id=17164a1e"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"

import "./Pedidos.vue?vue&type=style&index=0&id=17164a1e&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__